import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { completeLoginCallback, devModeEnabled } from "@/lib/auth";
import { LoadingState } from "@/components/common/LoadingState";
import { Button } from "@/components/ui/Button";

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (devModeEnabled()) {
      void navigate({ to: "/", replace: true });
      return;
    }
    completeLoginCallback()
      .then((returnTo) => {
        // SPA navigate to preserve module-level authStore (a full reload
        // would reset it and trigger the /login bounce loop).
        const target = returnTo && returnTo.startsWith("/") ? returnTo : "/";
        void navigate({ to: target, replace: true });
      })
      .catch((err: unknown) => setError(err instanceof Error ? err.message : String(err)));
  }, [navigate]);

  if (error) {
    return (
      <main
        style={{
          display: "flex",
          minHeight: "100vh",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          padding: 24,
          textAlign: "center",
          background: "var(--bg)",
          color: "var(--ink-1)",
          fontFamily: "Inter Variable, Inter, system-ui, sans-serif",
        }}
      >
        <h1 style={{ fontSize: 20, fontWeight: 600 }}>Anmeldung fehlgeschlagen</h1>
        <p style={{ maxWidth: 480, fontSize: 14, color: "var(--ink-3)" }}>{error}</p>
        <Button variant="primary" onClick={() => void navigate({ to: "/login", replace: true })}>
          Zurück zur Anmeldung
        </Button>
      </main>
    );
  }
  return <LoadingState label="Anmeldung wird abgeschlossen …" />;
}
